// extracted by mini-css-extract-plugin
export var address = "ClinicCard-module--address--e24f2";
export var clock = "ClinicCard-module--clock--33fc0";
export var cta = "ClinicCard-module--cta--baeb8";
export var current = "ClinicCard-module--current--5b062";
export var detailsLink = "ClinicCard-module--details-link--26275";
export var hours = "ClinicCard-module--hours--c19e7";
export var iconRow = "ClinicCard-module--icon-row--d10df";
export var location = "ClinicCard-module--location--c1595";